import { Content } from "@/components/layouts/content";
import { Header } from "@/components/layouts/header";
import UserCreateForm from "@/features/dashboard/components/user-create-from";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/user/create")({
	component: UserCreate,
});

function UserCreate() {
	return (
		<Content>
			<Header />
			<div className="flex flex-col w-full max-w-base p-6 gap-6">
				<div className="flex flex-col w-full">
					<UserCreateForm />
				</div>
			</div>
		</Content>
	);
}
